import I18n from 'app/i18n';
import NotificationStore from 'app/store/notifications';
import React from 'react';
import {APP_INSTALL_ASKED} from 'app/utils/Consts';
import {Link} from 'react-router-dom';
import {getLinkPath, isDesktop} from 'app/utils';
import Subscription from 'app/components/informers/subscription';

interface Props {
  onClose: (key?: string) => void;
}

const pwaInstallAsked = (): boolean => window.localStorage.getItem(APP_INSTALL_ASKED) === 'true';

const setPwaIntallFlag = (): void => {
    window.localStorage.setItem(APP_INSTALL_ASKED, 'true');
};

export default class PwaInstallNotification extends React.PureComponent<Props> {
    static inform(): void {
        if (pwaInstallAsked() || !isDesktop()) {
            Subscription.inform();
            return;
        }

        NotificationStore.add({showCloseButton: false,
            timeout: false,
            type: 'pwa_install_notifications'});
    }

    handleInstall = (): void => {
        setPwaIntallFlag();
        this.props.onClose();
        Subscription.inform();
    };

    handleClose = (e: React.MouseEvent<HTMLDivElement>): void => {
        e.preventDefault();
        setPwaIntallFlag();
        this.props.onClose();
        Subscription.inform();
    };

    render(): React.ReactNode {
        return <div className="notification__content">
            <div className="notification__content-wrap">
                <div className="notification__title">{I18n.t('app_egb')}</div>
                <div className="notification__text">{I18n.t('install_app_egb_and_get_quick_access')}</div>
            </div>
            <div className="notification__button-holder notification__button-holder--2btn">
                <Link className="btn" to={getLinkPath('/apps')} onClick={this.handleInstall}>{I18n.t('install')}</Link>
                <div className="btn btn--gray-invert js-close-block-btn" onClick={this.handleClose}>
                    {I18n.t('not_yet')}
                </div>
            </div>
        </div>;
    }
}
